<template>
    <div v-if="$route.meta.homePage && $mq=='sm'" class="transactionRecentMobile">
        <div class="sender">
            <img src="/assets/img/flynow_round.svg" alt="flynow">
        </div>
        <div class="description">
            <div class="title">{{ title }}</div>
            <div class="date">{{ date }}</div>
        </div>
        <div class="paymentDetails">
            <div class="amount" :class="debitOrCredit">{{ currencySign }}{{ amount }}</div>
        </div>
    </div>
    <div v-else class="transaction">
        <div v-if="$mq=='sm'" class="top">
            <div class="transactionType">{{ operation_type }}</div>
            <div class="date">{{ date }}</div>
        </div>
        <div class="bottom">
            <div class="titleWrap">
                <div v-if="$mq=='lg'" class="transactionType">{{ operation_type }}</div>
                <h4 class="title">{{ title }}</h4>
                <div v-if="description" class="desc">{{ description }}</div>
            </div>
            <div class="amountDetails">
                <div class="type" :class="debitOrCredit">{{ show_type }}</div>
                <div class="amountWrap">
                    <div v-if="$mq=='lg'" class="date">{{ date }}</div>
                    <div class="amount">{{ currencySign }} {{ amount }} <span class="currency">{{ currency.toUpperCase() }}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['operation_type', 'date', 'title', 'description', 'type', 'show_type', 'amount', 'currency'],

        computed: {
            currencySign: function() {
                return '';
                if (this.currency === 'gbp') {
                    return '£';
                }
            },
            debitOrCredit: function() {
                return this.type.toLowerCase() === 'debit' ? 'minus' : (this.type.toLowerCase()==='credit' ? 'plus' : 'other');
            }
        }
    }
</script>
